import { render, staticRenderFns } from "./DeleteRouteItem.vue?vue&type=template&id=1e89564c&"
import script from "./DeleteRouteItem.vue?vue&type=script&lang=js&"
export * from "./DeleteRouteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports